import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
    currentUserSubject: BehaviorSubject<User>;
    currentUser: Observable<User>;
    currentExpirationSubject: BehaviorSubject<Date>;
    expiration: Observable<Date>;
    expirationTimeInMinutes = 1440;

    constructor(private http: HttpClient) {
        this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUserPricingWeb')));
        this.currentUser = this.currentUserSubject.asObservable();

        this.currentExpirationSubject = new BehaviorSubject<Date>(new Date(localStorage.getItem('sessionExpirationPricingWeb')));
        this.expiration = this.currentExpirationSubject.asObservable();
    }

    public checkValidLoggedUser(): number {
        let currentDate = new Date();

        if (!this.currentUserValue) {
            return 1;
        }

        if (this.currentExpirationSubject.value && currentDate > this.currentExpirationSubject.value) {
            this.logout();
            
            return 2;
        }

        currentDate = new Date(currentDate.getTime() + (this.expirationTimeInMinutes * 60 * 1000));
        localStorage.setItem('sessionExpirationPricingWeb', currentDate.toString());
        this.currentExpirationSubject.next(currentDate);

        return 0;
    }

    public get currentUserValue(): User {
        return this.currentUserSubject.value;
    }

    login(username: string, password: string) {
        return this.http.post<any>(`${environment.API_PRICE}/account`, { username, password }).pipe(
            map(user => {
                const currentUser: User = <User>user;
                let expiration = new Date();
                expiration = new Date(expiration.getTime() + (this.expirationTimeInMinutes * 60 * 1000));

                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('currentUserPricingWeb', JSON.stringify(currentUser));
                localStorage.setItem('sessionExpirationPricingWeb', expiration.toString());
                this.currentUserSubject.next(currentUser);
                this.currentExpirationSubject.next(expiration);

                return currentUser;
            })
        );
    }

    logout() {
        // remove user from local storage and set current user to null
        localStorage.removeItem('currentUserPricingWeb');
        localStorage.removeItem('sessionExpirationPricingWeb');
        localStorage.removeItem('parametrosSistemaPW');
        
        this.currentUserSubject.next(null);
        this.currentExpirationSubject.next(null);
    }

    authenticationUserStatusMessage(statusCode: number) {
        switch(statusCode) {
            case 0:
                return null;
            case 1:
                return 'Usuário não logado. Favor efetuar o login.';
            case 2:
                return 'Sessão expirada, favor efetuar login novamente.';
            default:
                return null;
        }
    }
}

export class User {
    id: number;
    userName: string;
    email: string;
    perfilId: number;
    perfil: string;
}